var render = function () {
  var _vm$clearanceApproval, _vm$clearanceApproval2;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "1200px",
      "transition": "dialog-bottom-transition",
      "persistent": ""
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-open-in-new")]), _vm._v(" " + _vm._s(_vm.clearanceApproval.title) + " "), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click() {
        return _vm.close();
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-radio-group', {
    model: {
      value: _vm.status,
      callback: function callback($$v) {
        _vm.status = $$v;
      },
      expression: "status"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('components.PartnerReportDetail.repair.ReportClearanceApprovalUpdateStatusDialog.accept'),
      "value": _vm.RequestStatusEnum.ACCEPTED
    }
  }), _c('v-radio', {
    attrs: {
      "label": _vm.$t('components.PartnerReportDetail.repair.ReportClearanceApprovalUpdateStatusDialog.rejected_by_requested'),
      "value": _vm.RequestStatusEnum.REJECTED_BY_REQUESTED
    }
  }), _c('v-radio', {
    attrs: {
      "label": _vm.$t('components.PartnerReportDetail.repair.ReportClearanceApprovalUpdateStatusDialog.rejected_by_requesting'),
      "value": _vm.RequestStatusEnum.REJECTED_BY_REQUESTING
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('drop-area-multi', {
    staticClass: "mb-4",
    attrs: {
      "files": _vm.answerFiles,
      "text": _vm.$t('components.PartnerReportDetail.repair.ReportClearanceApprovalUpdateStatusDialog.document'),
      "loading": _vm.requestsLoading,
      "accept": ".pdf",
      "maxFiles": 1
    },
    on: {
      "update:files": function updateFiles($event) {
        _vm.answerFiles = $event;
      }
    }
  }), _vm.answerFile ? _c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "color": "error",
      "text": "",
      "small": ""
    },
    on: {
      "click": function click($event) {
        _vm.answerFile = null;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-delete")]), _vm._v(" " + _vm._s(_vm.$t("clearanceApproval.response.removeFile")) + " ")], 1) : _vm._e()], 1)], 1)], 1), _c('v-divider', {
    staticClass: "d-none d-md-block",
    attrs: {
      "vertical": ""
    }
  }), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.ReportClearanceApprovalUpdateStatusDialog.seller")) + " ")]), (_vm$clearanceApproval = _vm.clearanceApproval) !== null && _vm$clearanceApproval !== void 0 && _vm$clearanceApproval.seller ? _c('invoice-party-sheet', {
    attrs: {
      "invoice-party": (_vm$clearanceApproval2 = _vm.clearanceApproval) === null || _vm$clearanceApproval2 === void 0 ? void 0 : _vm$clearanceApproval2.seller
    }
  }) : _c('m-no-content', {
    attrs: {
      "text": _vm.$t('components.PartnerReportDetail.repair.ReportClearanceApprovalUpdateStatusDialog.noSeller')
    }
  })], 1)], 1)], 1), _c('v-card-actions', {
    staticClass: "mt-6 pa-4"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "elevation": "0",
      "disabled": !_vm.status,
      "loading": _vm.requestsLoading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.ReportClearanceApprovalUpdateStatusDialog.save")) + " ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }